/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box } from "../../../../components";
import { withProcedureWraper } from "../..";
import CreateRequestButton from "../../components/CreateRequestButton";
import { useHistory } from "react-router-dom";
import { PATH } from "./constant/path";
import { MyRequests } from "./components/my-requests";
import { MyApprovals } from "./components/my-approvals";

export const StationaryRequest = withProcedureWraper(() => {
  const history = useHistory();

  return (
    <div className="pd15" >
      <div
        className="text-md-left font-weight-normal p-3 bg-info text-white"
        style={{ fontSize: "14px" }}
      >
        <div className="row title__process-container">
          <div className="">Phiếu đề nghị văn phòng phẩm</div>
          <div className="See-User-Manual">
            <a
              href="#"
              target="_blank"
              rel="noreferrer"
              className="See-User-Manual ml-1"
            >
              Xem hướng dẫn sử dụng
            </a>
          </div>
        </div>
      </div>

      <Box
        title="Yêu cầu của tôi"
        titleRight={
          <CreateRequestButton onClick={() => history.push(PATH.CREATE.replace(":id","0"))} />
        }
      >
        <MyRequests />
      </Box>
      <Box title="Các yêu cầu cần duyệt">
        <MyApprovals />
      </Box>
    </div>
  );
});
